import { Button } from '@material-ui/core';
import React, { memo, useState, useMemo } from 'react';
import {
    buildBackToBeginMessage,
    buildDataFormQAAfterSubmit,
    checkMessageOutOfSession,
    createMessageList,
    deleteMsgQA,
    postMessage,
    checkDataChangeInChatbot,
    buildFreeMessage,
    buildTheEndMessage,
    buildQAFormLiveChat
} from '../handler/ChatBoxHandler';
import { yupResolver } from '@hookform/resolvers';
import { FormProvider, useForm } from 'react-hook-form';
import CreateTicketQAInChatbotSchema from '@/schema/CreateTicketQAInChatbotSchema';
import RenderFieldUI from '@/component/formManagement/RenderFieldUI';
import Utils from '@/common/utils/utils';
import FormInput from '@/component/common/form/input';
import Constant from '@/common/constant/Constant';
import SystemField, { TmpHiddenSysfieldInCreateTicket } from '@/common/constant/SystemField';
import { useEffect } from 'react';
import '@/component/multiPanel/TicketDetail.css';
import { isInputAllFieldRequired } from '@/component/ticketList/handler/CreateTicketCommonHandler';
import { cloneDeep } from 'lodash';
import { getPublicAPI } from '@/service/publicService';
import { validateErrorTicket } from '@/component/common/ValidateTicket';
import {
    onSubmitCreateAnonymousQa,
    onSubmitCreateAnonymousNormal
} from '@/component/supportIframe/handler/AnonymousQAHandler';
import { DialogConfirmPassword } from './DialogConfirmPassword';
import {
    getFormByIdWithoutAuthen,
    getInfoFormFieldWithoutAuthen
} from '@/service/formManagementService';
import LoadingMessage from '../LoadingMessage';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaDataContentOperation, getLastQaCategory } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { useRecoilState } from 'recoil';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import trI18n from '@/common/utils/trI18n';

function QAFormInChatbot({
    message,
    setMessages,
    settingChatBot,
    messages,
    supportThreadIdState,
    affiliationOrganization,
    isModePreview,
    listCategories,
    API,
    categoryIdSelected,
    projectId,
    setFormDataTransfer,
    isMaximizedPanel,
    projectAlias,
    subDomain,
    setIsShowModalReload,
    isIframeChatBot,
    getMessage,
    resolvedMessages
}) {
    const getSelectedOption = () => {
        let selectedOption = {};
        if (!Utils.isEmptyArray(messages)) {
            let lastCategoryListSelected = {};
            messages.forEach(messageItem => {
                if (messageItem.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM) {
                    lastCategoryListSelected = messageItem;
                }
            });

            if (!Utils.isEmptyObject(lastCategoryListSelected)) {
                let lastCategorySelectedId = lastCategoryListSelected.idMessage;
                messages.forEach(msgItem => {
                    if (
                        msgItem.messageType ===
                            Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SELECT_TAG_ITEM &&
                        msgItem.idMessage > lastCategorySelectedId &&
                        msgItem.idOfTagField &&
                        msgItem.idOfOption
                    ) {
                        if (selectedOption.hasOwnProperty(msgItem.idOfTagField)) {
                            selectedOption[msgItem.idOfTagField].push(msgItem.idOfOption);
                        } else {
                            selectedOption[msgItem.idOfTagField] = [msgItem.idOfOption];
                        }
                    }
                });
            }
        }

        return selectedOption;
    };

    let selectedTagItemDataList = getSelectedOption();
    // field list data
    const [fieldListData, setFieldListData] = useState([]);
    let [formSaveData, setFormSaveData] = useState(selectedTagItemDataList);
    // selected form detail
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [autoFillObject, setAutoFillObject] = useState({});
    const [isExChangeTagField, setIsExChangeTagField] = useState(false);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [isEdited, setIsEdited] = useState(false);
    const [isDisableBtnSubmit, setIsDisableBtnSubmit] = useState(true);
    const [infoB2C, setInfoB2C] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showDialog, setShowDialog] = useState({ isOpen: false });
    const [isLoadingQAForm, setIsLoadingQAForm] = useState(false);
    const [listCategorieQA, setListCategorieQA] = useState(listCategories);
    const [messageState, setMessagesState] = useState(message)
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);

    useEffect(() => {
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])

    const anonymousUserInfoKey = [
        'mailAddress',
        'reEmailAddress',
        'firstName',
        'lastName',
        'lastNameKana',
        'firstNameKana'
    ];

    // Create validation messages object using getMessage
    const validationMessages = useMemo(() => {
        return {
            form_invalid_msg_required: getMessage('form_invalid_msg_required'),
            form_invalid_msg_email_invalid: getMessage('form_invalid_msg_email_invalid'),
            form_invalid_msg_email_max_length: getMessage('form_invalid_msg_email_max_length', { maxLength: 200 }),
            form_invalid_msg_email_confirm_mismatch: getMessage('form_invalid_msg_email_confirm_mismatch'),
            form_invalid_msg_name_max_length: getMessage('form_invalid_msg_name_max_length', { maxLength: 128 })
        };
    }, [getMessage]);

    // Create resolver with dependencies on fieldListData and validationMessages
    const validationResolver = useMemo(() => {
        return yupResolver(CreateTicketQAInChatbotSchema(fieldListData, validationMessages));
    }, [fieldListData, validationMessages]);

    const validateCreateTicket = useForm({
        mode: 'all',
        shouldUnregister: true,
        defaultValues: {
            outline: '',
            category: '',
            description: '',
            field_qa_category: []
        },
        resolver: validationResolver
    });

    const onSubmitCreateTicket = async data => {
        setIsLoading(true);
        let formData = {};
        for (const key in data) {
            if (!anonymousUserInfoKey.includes(key)) {
                formData[`${key}`] = data[`${key}`];
            }
        }
        const fields = await Utils.getCustomFieldValueInFormData(formData, fieldListData);
        // validate
        if (validateErrorTicket({ fieldListData: fieldListData }, fields)) {
            setIsLoading(false);
            return;
        }

        if (isModePreview) {
            let dataQA = {
                fieldListData: fieldListData,
                formDataTranfer: data,
                fileUploadList: fileUploadList
            };
            return sendMsgAfterSubmit(dataQA);
        }

        let params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.VERIFY_CREATE_TICKET_ANONYMOUS_QA,
            corporationId: affiliationOrganization,
            emailB2C: data.mailAddress
        };

        let formDetails = await getFormByIdWithoutAuthen(API, data.formSelected);

        if (Utils.isEmptyObject(formDetails)) {
            setIsLoading(false);
            return;
        }

        if (!formDetails.usingProjects.includes(projectId)) {
            setIsShowModalReload(true);
            return;
        }

        let categoryId = messageState?.content[0]?.data?.data.categoryIdSelected;

        let validatedChangeData = await checkDataChangeInChatbot(
            projectAlias,
            subDomain,
            settingChatBot,
            categoryId,
            listCategorieQA,
            projectId,
            isIframeChatBot
        );

        if (!validatedChangeData.status && Utils.isEmptyObject(validatedChangeData.chatbotSettingNew)) {
            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        if (
            !validatedChangeData.status &&
            !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew) &&
            validatedChangeData.chatbotSettingNew?.actionWhenNotResolve ===
                settingChatBot.actionWhenNotResolve
        ) {
            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        if (
            !validatedChangeData.status &&
            !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew) &&
            validatedChangeData.chatbotSettingNew?.actionWhenNotResolve ===
            Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE
        ) {
            deleteMsgQA(
                supportThreadIdState,
                affiliationOrganization,
                false,
                isModePreview,
                messageState?.content[0]?.data?.idQA
            );

            const freeMessage = buildFreeMessage(validatedChangeData.chatbotSettingNew.freeMsg, 0);
            const theEndMessage = buildTheEndMessage(
                1,
                messageState?.content[0]?.data?.data.formQASystem,
                resolvedMessages
            );
            createMessageList(
                [freeMessage, theEndMessage],
                supportThreadIdState,
                affiliationOrganization,
                isModePreview
            );

            setIsShowModalReload(true);
            return setIsLoading(false);
        }

        if (
            !validatedChangeData.status &&
            !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew) &&
            validatedChangeData.chatbotSettingNew?.actionWhenNotResolve ===
            Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT
        ) {
            deleteMsgQA(
                supportThreadIdState,
                affiliationOrganization,
                false,
                isModePreview,
                messageState?.content[0]?.data?.idQA
            );

            let dataLiveChat = {
                isDefault: false,
                categoryIdSelected: messageState?.content[0]?.data?.data?.categoryIdSelected,
                formQASystem: messageState?.content[0]?.data?.data.formQASystem
            };
            const newMessages = buildQAFormLiveChat(dataLiveChat, resolvedMessages);

            createMessageList(
                [newMessages],
                supportThreadIdState,
                affiliationOrganization,
                isModePreview
            );

            setIsShowModalReload(true);
            return setIsLoading(false);
    }
        
        let result = await getPublicAPI(API, params);

        if (result.success) {
            // check user exist in corp
            let payload = Utils.convertJSONDataToObject(result.payload);
            let userByEmailInCorp = payload.userByEmailInCorp;
            if (
                !Utils.isEmptyObject(userByEmailInCorp) &&
                (userByEmailInCorp.type === Constant.USER_TYPE.GENERAL ||
                    userByEmailInCorp.type === Constant.USER_TYPE.INTERNAL)
            ) {
                setErrorCreateTicket(
                    'mailAddress',
                    { type: 'mailAddress', message: trI18n('USER11MSG004') },
                    { shouldFocus: true }
                );
                setIsLoading(false);
                return;
            }
            

            setFormDataTransfer(data);

            let cloneData = cloneDeep(data);
            for (const fieldId in cloneData) {
                let field = fieldListData.find(x => x.id === fieldId);
                if (field && field.type === Constant.FORM_TYPE.FIELD_URL && cloneData[fieldId]) {
                    cloneData[fieldId] = cloneData[fieldId]?.split('\n');
                }

                if (field && field.type === Constant.FORM_TYPE.FIELD_TAG && cloneData[fieldId]) {
                    let tagFiledValue = cloneData[fieldId];
                    let listTagItem = [];
                    for (let i = 0; i < cloneData[fieldId].length; i++) {
                        listTagItem.push(tagFiledValue[i].value);
                    }
                    cloneData[fieldId] = JSON.stringify(listTagItem);
                }
            }
            setFormSaveData(cloneData);

            const paramsCreatAnonymous = {
                getApiType: Constant.GET_API_PUBLIC_TYPE.VERIFY_CONFIRM_TICKET_ANONYMOUS_QA,
                corporationId: affiliationOrganization,
                emailB2C: data.mailAddress,
                projectId: projectId
            };

            let results = await getPublicAPI(API, paramsCreatAnonymous);
            let infoBC2InCorp = {};
            let listB2CInProj = [];
            let isCustomerInvitationSettingOff = false;
            if (result.success) {
                let payloads = Utils.convertJSONDataToObject(results.payload);
                infoBC2InCorp = payloads.infoBC2InCorp;
                listB2CInProj = payloads.listB2CInProj;
                isCustomerInvitationSettingOff = payloads.isCustomerInvitationSettingOff;
            }

            let infoB2CInProj = listB2CInProj.find(item => {
                return item.id === infoBC2InCorp.id;
            });

            if (!Utils.isEmptyObject(infoBC2InCorp)) {
                setInfoB2C(infoBC2InCorp);
            }

            // B2C In Corp AND B2C In Project
            if (!Utils.isEmptyObject(infoBC2InCorp) && !Utils.isEmptyObject(infoB2CInProj)) {
                // B2C In Project with Status = Active
                if (
                    infoB2CInProj?.mail === data.mailAddress &&
                    infoB2CInProj?.activeInProject === Constant.ACTIVE_FLAG.ACTIVE &&
                    infoB2CInProj?.active === Constant.ACTIVE_FLAG.ACTIVE
                ) {
                    // Check B2C Loging
                    // let statusB2CAuth = localStorageUtil.getItem('amplify-authenticator-authState');
                    // if (Constant.USER_SIGNED_IN === statusB2CAuth) {
                    //     handleSubmitCreateTicket(data, formData, false, infoBC2InCorp);
                    // } else {
                        if (isCustomerInvitationSettingOff) {
                            handleSubmitCreateTicket(data, formData, false, infoBC2InCorp);
                        } else {
                            setShowDialog({
                                isOpen: true,
                                formDataTranfer: data,
                                formData: formData,
                                infoB2CInCorp: infoBC2InCorp
                            });
                            setIsLoading(false);
                        }
                    //}
                } else {
                    handleSubmitCreateTicket(data, formData);
                }
            } else {
                //create QA anonymous
                if (!Utils.isEmptyObject(infoBC2InCorp)) {
                    await handleSubmitCreateTicket(data, formData, true, infoBC2InCorp);
                } else {
                    await handleSubmitCreateTicket(data, formData);
                }
            }
        }
    };

    const handleClose = () => {
        setShowDialog(prev => ({ ...prev, isOpen: false }));
    };

    const handleSubmitCreateTicket = async (data, formData, isAnonymous = true, infoBC2InCorp) => {
        let infoB2CInCorp = cloneDeep(infoB2C);
        if (!Utils.isEmptyObject(infoBC2InCorp)) {
            infoB2CInCorp = infoBC2InCorp;
        }
        let anonymousUserInfo = {},
            submitResponse = {};
        for (const key in data) {
            if (anonymousUserInfoKey.includes(key)) {
                anonymousUserInfo[`${key}`] = data[`${key}`] ? data[`${key}`] : '';
            }
        }
        anonymousUserInfo.type = Constant.ANONYMOUS_TYPE.CHATBOT;
        formData.fileUploadList = fileUploadList;
        let params = {
            API: API,
            setFileUploading: setFileUploading
        };
        if (isAnonymous) {
            submitResponse = await onSubmitCreateAnonymousQa(
                params,
                formData,
                anonymousUserInfo,
                affiliationOrganization,
                projectId,
                fieldListData,
                infoB2CInCorp,
                true
            );
        } else {
            submitResponse = await onSubmitCreateAnonymousNormal(
                params,
                formData,
                infoB2CInCorp,
                affiliationOrganization,
                projectId,
                fieldListData,
                anonymousUserInfo
            );
        }

        if (submitResponse?.data?.id) {
            //redirect
            deleteMsgQA(
                supportThreadIdState,
                affiliationOrganization,
                false,
                isModePreview,
                messageState?.content[0]?.data?.idQA
            );
            handleClose();
            let dataQA = {
                fieldListData: fieldListData,
                formDataTranfer: data,
                fileUploadList: fileUploadList
            };
            setIsLoading(false);
            let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
            let dataLog = {
                rootCorporationDetail: {
                    id: affiliationOrganization
                },
                rootProjectDetail: {
                    id: projectId
                },
                corporationDetail: {},
                projectDetail: {},
                userDetail: {
                    mail: data.mailAddress,
                    lastName: JSON.stringify({
                        jp: {
                            A: "F",
                            text: data.lastName
                        }
                    }),
                    firstName: JSON.stringify({
                        jp: {
                            A: "F",
                            text: data.firstName
                        }
                    })
                },
                ticketDetail: {
                    id: submitResponse?.data?.id,
                    outline: submitResponse?.data?.outline,
                    creator: '',
                    usingFormName: '',
                    createdAt: submitResponse?.data?.createdAt,
                    creatorEmail: data.mailAddress,
                    createrUserName: data.lastName + " " + data.firstName
                },
                metaData: {
                    formDetailId: formData.formSelected,
                    ticketType: Constant.TICKET_TYPE.QA
                },
                qaCategory: getLastQaCategory(messages),
                ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.KNOWLEDGE_ROBO
            }
        
            let logKibanaData = createKibanaDataContentOperation(
                lastUserAction,
                dataLog
            );
            let param = {
                logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
                logKibanaData: logKibanaData
            };
            createKibanaLogAPI(API, param);
            setLastUserAction(null)
            return sendMsgAfterSubmit(dataQA);
        } else if (!Utils.isEmptyArray(submitResponse.errors)) {
            setIsLoading(false);
            let messageCode = submitResponse.errors[0].message;
            if (messageCode === 'USER01MSG001') {
                setErrorCreateTicket(
                    'mailAddress',
                    { type: 'mailAddress', message: trI18n('USER01MSG001') },
                    { shouldFocus: true }
                );
            }
        }
    };

    const handleSubmitCreateTickets = validateCreateTicket.handleSubmit;
    const errorCreateTicket = validateCreateTicket.errors;
    const clearErrors = validateCreateTicket.clearErrors;
    const setValueCreateTicket = validateCreateTicket.setValue;
    const registerCreateTicket = validateCreateTicket.register;
    const getValuesCreateTicket = validateCreateTicket.getValues;
    const setErrorCreateTicket = validateCreateTicket.setError;
    const triggerValidate = validateCreateTicket.trigger;

    // Re-validate fields with errors when validationMessages changes (language change)
    useEffect(() => {
        const errorFields = Object.keys(errorCreateTicket);
        if (errorFields.length > 0) {
            errorFields.forEach(fieldName => {
                triggerValidate(fieldName);
            });
        }
    }, [validationMessages]);

    const onCancelQAForm = () => {
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const newMessage = buildBackToBeginMessage(
            'USER11MSG001',
            0,
            messageState?.content[0]?.data?.data.formQASystem,
            resolvedMessages
        );
        deleteMsgQA(
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview,
            messageState?.content[0]?.data?.idQA
        );
        postMessage(
            newMessage,
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview
        );
        setMessages(prev => [...prev.slice(0, -1), newMessage]);
    };

    const sendMsgAfterSubmit = data => {
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const messageQA = buildDataFormQAAfterSubmit(data, 0, Constant.ANONYMOUS_TYPE.CHATBOT);
        const messageBackToBegin = buildBackToBeginMessage(
            'USER11MSG001',
            1,
            messageState?.content[0]?.data?.data.formQASystem,
            resolvedMessages
        );
        createMessageList(
            [messageQA, messageBackToBegin],
            supportThreadIdState,
            affiliationOrganization,
            isModePreview
        );
        setMessages(prev => [...prev.slice(0, -1), messageQA, messageBackToBegin]);
    };

    const getFormFieldData = (formStructure, fieldList) => {
        let formData = [];

        if (!Utils.isEmptyObject(formStructure)) {
            for (const fieldNumber in formStructure) {
                if (formStructure.hasOwnProperty(fieldNumber)) {
                    let fieldData = {};
                    let fieldId = '';
                    let formField = formStructure[fieldNumber];

                    if (
                        formStructure[fieldNumber].hasOwnProperty('field') &&
                        !Utils.isEmptyArray(fieldList)
                    ) {
                        fieldId = formStructure[fieldNumber]['field'];
                        fieldData = fieldList.find(customField => customField.id === fieldId);
                        if (!Utils.isEmptyObject(fieldData)) fieldData.structure = Utils.convertJSONDataToObject(fieldData?.structure);
                    } else if (
                        formStructure[fieldNumber].hasOwnProperty('sysfield') &&
                        !Utils.isEmptyArray(SystemField)
                    ) {
                        fieldId = formStructure[fieldNumber]['sysfield'];
                        fieldData = SystemField.find(systemField => systemField.id === fieldId);
                    }

                    if (!Utils.isEmptyObject(fieldData)) {
                        fieldData.fieldId = fieldId;
                        fieldData.fieldLabel = fieldData.name;
                        fieldData.structure.required = formField.required;
                        fieldData.structure.publicForCustomer = formField.publicForCustomer;
                        formData.push(fieldData);
                    }
                }
            }
        }

        return formData;
    };

    const getFormSelectedFromQACategory = async (categoryId, data) => {
        if (Utils.isEmpty(listCategorieQA)) return;
        let categoryDetailList = listCategorieQA.filter(category => category.id === categoryId);
        let resFormField = categoryDetailList[0]?.formfieldAnonymous;

        // get new info form ---------------------------
        let formId = resFormField?.id;
        if(isModePreview) {
            formId = categoryDetailList[0].chatBotCategorySetting?.formId;
        }
        let formfieldAnonymous = await getInfoFormFieldWithoutAuthen(API, formId);
        // new info form --------------------------------
        if (
            Utils.isEmptyObject(formfieldAnonymous) ||
            Utils.isEmptyString(formfieldAnonymous?.id)
        ) {
            return getFormSystemQA(data);
        }

        if (!formfieldAnonymous?.usingProjects.includes(projectId)) {
            return getFormSystemQA(data);
        }

        setValueCreateTicket('formSelected', formfieldAnonymous?.id);
        let getFieldListResult = getFormFieldData(
            formfieldAnonymous?.structure,
            formfieldAnonymous?.listFieldDetail
        );
        getFieldListResult = getFieldListResult.filter(x => {
            return (
                (Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW) &&
                !TmpHiddenSysfieldInCreateTicket.includes(x.sysField)
            );
        });
        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }
            return field;
        });

        // Get field order in form
        let fieldOrderInForm = {};

        if (!Utils.isEmptyObject(formfieldAnonymous?.structure)) {
            for (const [structureKey, structureValue] of Object.entries(
                formfieldAnonymous?.structure
            )) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }

        getFieldListResult = getFieldListResult
            .filter(field => {
                if (!field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField))
                    return true;
                return false;
            })
            .filter(
                field =>
                    field?.sysField ||
                    field?.usingProjects?.includes(formfieldAnonymous?.affiliationProject)
            )
            .sort((a, b) => {
                if (a.sysField === 'attachments') {
                    return 1; // put `specificItem` at the bottom
                }

                if (b.sysField === 'attachments') {
                    return -1; // put `specificItem` at the bottom
                }

                // if (!a.order || !b.order) return 1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });

        setFieldListData([...getFieldListResult]);
        setFormSaveData(selectedTagItemDataList);
    };

    const getFormSystemQA = data => {
        let formfieldAnonymous = data;
        setValueCreateTicket('formSelected', formfieldAnonymous?.id);
        let getFieldListResult = getFormFieldData(
            formfieldAnonymous?.structure,
            formfieldAnonymous?.listFieldDetail
        );
        getFieldListResult = getFieldListResult.filter(x => {
            return (
                (Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW) &&
                !TmpHiddenSysfieldInCreateTicket.includes(x.sysField)
            );
        });
        getFieldListResult = Array.from(getFieldListResult, field => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }
            return field;
        });

        // Get field order in form
        let fieldOrderInForm = {};

        if (!Utils.isEmptyObject(formfieldAnonymous?.structure)) {
            for (const [structureKey, structureValue] of Object.entries(
                formfieldAnonymous?.structure
            )) {
                if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                    fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
                }
            }
        }

        getFieldListResult = getFieldListResult
            .filter(
                field =>
                    !field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField)
            )
            .sort((a, b) => {
                if (a.sysField === 'attachments') {
                    return 1; // put `specificItem` at the bottom
                }

                if (b.sysField === 'attachments') {
                    return -1; // put `specificItem` at the bottom
                }

                // if (!a.order || !b.order) return 1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });

        setFieldListData([...getFieldListResult]);
        setFormSaveData(selectedTagItemDataList);
    };

    const checkIsDisableBtnSubmit = () => {
        let mailAddress = getValuesCreateTicket('mailAddress');
        let reEmailAddress = getValuesCreateTicket('reEmailAddress');
        if (Utils.isEmptyString(mailAddress) || Utils.isEmptyString(reEmailAddress)) {
            return setIsDisableBtnSubmit(true);
        }

        if (!Utils.isEmptyObject(errorCreateTicket)) {
            return setIsDisableBtnSubmit(true);
        }

        if (!isInputAllFieldRequired(fieldListData, getValuesCreateTicket, fileUploadList)) {
            return setIsDisableBtnSubmit(true);
        }

        return setIsDisableBtnSubmit(false);
    };

    const verifyPassword = async (formDataTransfer, formData, infoB2CInCorp) => {
        handleSubmitCreateTicket(formDataTransfer, formData, false, infoB2CInCorp);
    };

    useEffect(() => {
        (async () => {
            setIsLoadingQAForm(true);
            registerCreateTicket('formSelected');
            let isDefault = messageState?.content[0]?.data?.isDefault;
            if (!isDefault) {
                await getFormSelectedFromQACategory(
                    messageState?.content[0]?.data?.data?.categoryIdSelected,
                    messageState?.content[0]?.data?.data.formQASystem
                );
                setIsLoadingQAForm(false);
            } else {
                getFormSystemQA(messageState?.content[0]?.data?.data?.formQASystem);
                setIsLoadingQAForm(false);
            }
        })();
    }, [categoryIdSelected, message?.content[0]?.data?.data?.formQASystem]);

    useEffect(() => {
        checkIsDisableBtnSubmit();
    });

    const toProps = {
        showDialog,
        setShowDialog,
        setIsLoading,
        affiliationOrganization,
        projectId,
        handleSubmitCreateTicket
    };

    const getDefaultValueOfField = fieldData => {
        if (!fieldData || !fieldData.fieldId) return;

        return formSaveData && formSaveData[fieldData.fieldId]
            ? formSaveData[fieldData.fieldId]
            : null;
    };
    return (
        <div className={isMaximizedPanel ? 'message-text maximized-form-text' : 'message-text'}  >
            {isLoadingQAForm ? <LoadingMessage /> : (
                <div>
                    <div>
                        {
                            ['CBOTMSG011', 'CBOTLB009'].includes(messageState?.content?.[0]?.msgKey)
                                ? getMessage('bot_form_qa_prompt')
                                : messageState?.content?.[0]?.msgKey
                        }
                    </div>
                    <div className="info-form-anonymous">
                        <FormProvider {...validateCreateTicket}>
                            <div className="form-addTicket">
                                <label className="form-addTicket-label">
                                    {getMessage('form_email_label')}
                                    <span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input">
                                    <FormInput
                                        variant="outlined"
                                        name="mailAddress"
                                        required={true}
                                        errorlist={errorCreateTicket}
                                        className="form-control-input form-control-wrapInput form-control-hg32"
                                        defaultValue={formSaveData ? formSaveData.mailAddress : ''}
                                        placeholder={getMessage('form_email_placeholder')}
                                    />
                                </div>
                            </div>
                            <div className="form-addTicket">
                                <label className="form-addTicket-label">
                                    {getMessage('form_email_confirm_label')}<span className="required">*</span>
                                </label>
                                <div className="form-addTicket-input">
                                    <FormInput
                                        variant="outlined"
                                        name="reEmailAddress"
                                        required={true}
                                        errorlist={errorCreateTicket}
                                        className="form-control-input form-control-wrapInput form-control-hg32"
                                        defaultValue={
                                            formSaveData ? formSaveData.reEmailAddress : ''
                                        }
                                        placeholder={getMessage('form_email_placeholder')}
                                    />
                                </div>
                            </div>

                            <div className="group-form-row">
                                <div className="group-col">
                                    <label className="form-addTicket-label">{getMessage('form_last_name_label')}</label>
                                    <div className="form-addTicket-input">
                                        <FormInput
                                            variant="outlined"
                                            name="lastName"
                                            required={true}
                                            errorlist={errorCreateTicket}
                                            className="form-control-input form-control-wrapInput form-control-hg32"
                                            defaultValue={formSaveData ? formSaveData.lastName : ''}
                                            placeholder={getMessage('form_last_name_placeholder')}
                                        />
                                    </div>
                                </div>
                                <div className="group-col">
                                    <label className="form-addTicket-label">{getMessage('form_first_name_label')}</label>
                                    <div className="form-addTicket-input">
                                        <FormInput
                                            variant="outlined"
                                            name="firstName"
                                            required={true}
                                            errorlist={errorCreateTicket}
                                            className="form-control-input form-control-wrapInput form-control-hg32"
                                            defaultValue={
                                                formSaveData ? formSaveData.firstName : ''
                                            }
                                            placeholder={getMessage('form_first_name_placeholder')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="group-form-row">
                                <div className="group-col">
                                    <label className="form-addTicket-label">{getMessage('form_last_name_kana_label')}</label>
                                    <div className="form-addTicket-input">
                                        <FormInput
                                            variant="outlined"
                                            name="lastNameKana"
                                            required={true}
                                            errorlist={errorCreateTicket}
                                            className="form-control-input form-control-wrapInput form-control-hg32"
                                            defaultValue={
                                                formSaveData ? formSaveData.lastNameKana : ''
                                            }
                                            placeholder={getMessage('form_last_name_kana_placeholder')}
                                        />
                                    </div>
                                </div>
                                <div className="group-col">
                                    <label className="form-addTicket-label">{getMessage('form_first_name_kana_label')}</label>
                                    <div className="form-addTicket-input">
                                        <FormInput
                                            variant="outlined"
                                            name="firstNameKana"
                                            required={true}
                                            errorlist={errorCreateTicket}
                                            className="form-control-input form-control-wrapInput form-control-hg32"
                                            defaultValue={
                                                formSaveData ? formSaveData.firstNameKana : ''
                                            }
                                            placeholder={getMessage('form_first_name_kana_placeholder')}
                                        />
                                    </div>
                                </div>
                            </div>

                            {!Utils.isEmptyArray(fieldListData) &&
                                fieldListData
                                    ?.filter(field => field.type !== 'WORKFLOW')
                                    .map((fieldData, i) => (
                                        <RenderFieldUI
                                            API={API}
                                            UI={fieldData.structure.UI}
                                            isNotAuthen={true}
                                            label={
                                                fieldData.fieldLabel
                                                    ? Utils.getTextByLanguage(
                                                          Constant.LANGUAGE_TYPE.JP,
                                                          fieldData.fieldLabel
                                                      )
                                                    : ''
                                            }
                                            errorlist={errorCreateTicket}
                                            name={fieldData.fieldId}
                                            data={fieldData}
                                            key={fieldData.fieldId}
                                            defaultValue={getDefaultValueOfField(fieldData)}
                                            triggerValidate={triggerValidate}
                                            // Drop file props
                                            fileUploadList={fileUploadList}
                                            setFileUploadList={setFileUploadList}
                                            register={registerCreateTicket}
                                            setValue={setValueCreateTicket}
                                            getValues={getValuesCreateTicket}
                                            clearErrors={clearErrors}
                                            autoFillObject={autoFillObject}
                                            setAutoFillObject={setAutoFillObject}
                                            isExChangeTagField={isExChangeTagField}
                                            setIsExChangeTagField={setIsExChangeTagField}
                                            listFieldEdited={listFieldEdited}
                                            setListFieldEdited={setListFieldEdited}
                                            isEdited={isEdited}
                                            setIsEdited={setIsEdited}
                                            isMaximizedPanel={isMaximizedPanel}
                                            isTooltipTitle={true}
                                            isLoading={isLoading}
                                            setIsLoading={setIsLoading}
                                        />
                                    ))}
                        </FormProvider>
                    </div>
                    <div className='submit-form-anonymous-chatbot-group-btn'>
                        <Button
                            className={`submit-form-anonymous-chatbot ${isDisableBtnSubmit &&
                                'submit-form-anonymous-chatbot-disabled'}`}
                            disabled={isDisableBtnSubmit || isLoading}
                            onClick={handleSubmitCreateTickets(
                                async data => await onSubmitCreateTicket(data)
                            )}
                        >
                            {isLoading ? (
                                <span className="lds-dual-ring"></span>
                            ) : (
                                getMessage('form_submit_button')
                            )}
                        </Button>
                        <Button className={`cancel-form-anonymous-chatbot`} onClick={onCancelQAForm}>
                            {getMessage('form_cancel_button')}
                        </Button>
                    </div>
                </div>
            )}
            <DialogConfirmPassword {...toProps} verifyPassword={verifyPassword} API={API}/>
        </div>
    );
}


export default memo(QAFormInChatbot)
